import { render, staticRenderFns } from "./en_yszc.vue?vue&type=template&id=50c7a716&scoped=true"
import script from "./en_yszc.vue?vue&type=script&lang=js"
export * from "./en_yszc.vue?vue&type=script&lang=js"
import style0 from "./en_yszc.vue?vue&type=style&index=0&id=50c7a716&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c7a716",
  null
  
)

export default component.exports